export const introduce = {
  text: '该指标统计了持有余额  > 1K 的链上地址总量，即巨鲸地址数量。',
  height: 1200,
};
